module.exports = __webpack_public_path__ + "img/seo_glotto_item02.8dd0d03.webp";